import React from 'react'
import PropTypes from 'prop-types'
import { withTabs } from './withTabs'
import ElementTabC from './ElementTabs/ElementTabC'
import WrapperTabC from './WrapperTabs/WrapperTabC'
import ElementTabD from './ElementTabs/ElementTabD'
import WrapperTabD from './WrapperTabs/WrapperTabD'
import ElementTabE from './ElementTabs/ElementTabE'
import WrapperTabE from './WrapperTabs/WrapperTabE'

/**
 *  How to use
 *  Insert React Component as a child of Tabs
 *  <Tabs> ... </Tabs>
 *
 *  Tabs props
 *
 *  Child will accept mainly 3 props to adjust each tab
 *  1. tabValue (required) unique id for each tab
 *  2. tabLabel: label that will be displayed in tab
 *
 */

class Tabs extends React.PureComponent {
  render() {
    return (
      <div className="tabs">
        {this.props.children}
      </div>
    )
  }
}

const createElementTabs = ({ ElementTab, WrapperTab }) => withTabs(ElementTab)(
  ({
    style = {},
    children,
    renderTabs,
    renderContent,
  }) => {
    return (
      <div style={style}>
        <WrapperTab>
          {renderTabs(children)}
        </WrapperTab>
        {renderContent(children)}
      </div>
    )
  }
)

createElementTabs.propTypes = {
  onTouchTab: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.object)]).isRequired,
}

Tabs.C = createElementTabs({ ElementTab: ElementTabC, WrapperTab: WrapperTabC })
Tabs.D = createElementTabs({ ElementTab: ElementTabD, WrapperTab: WrapperTabD })
Tabs.E = createElementTabs({ ElementTab: ElementTabE, WrapperTab: WrapperTabE })

export default Tabs



// WEBPACK FOOTER //
// ./src/components/Tabs/Tabs.js